module.exports = __webpack_public_path__ + "img/baidu.fab29803.png";